import React from "react";
import type { SpacerBlock } from '../../domain/types';
import { presentationTableProps } from '../table';
import type { BlockRenderProps } from './types';

export function renderSpacerBlock({
  block,
}: BlockRenderProps & { block: SpacerBlock }) {
  return (
    <table {...presentationTableProps()}>
      <tbody>
        <tr>
          <td
            style={{
              height: block.height,
              lineHeight: `${block.height}px`,
              fontSize: 0,
            }}>
            &nbsp;
          </td>
        </tr>
      </tbody>
    </table>
  );
}
